"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPropertyTypesResponseDto = instanceOfPropertyTypesResponseDto;
exports.PropertyTypesResponseDtoFromJSON = PropertyTypesResponseDtoFromJSON;
exports.PropertyTypesResponseDtoFromJSONTyped = PropertyTypesResponseDtoFromJSONTyped;
exports.PropertyTypesResponseDtoToJSON = PropertyTypesResponseDtoToJSON;
exports.PropertyTypesResponseDtoToJSONTyped = PropertyTypesResponseDtoToJSONTyped;
var PropertyTypeItemDto_1 = require("./PropertyTypeItemDto");
/**
 * Check if a given object implements the PropertyTypesResponseDto interface.
 */
function instanceOfPropertyTypesResponseDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function PropertyTypesResponseDtoFromJSON(json) {
    return PropertyTypesResponseDtoFromJSONTyped(json, false);
}
function PropertyTypesResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (json['data'].map(PropertyTypeItemDto_1.PropertyTypeItemDtoFromJSON)),
        'error': json['error'] == null ? undefined : json['error'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function PropertyTypesResponseDtoToJSON(json) {
    return PropertyTypesResponseDtoToJSONTyped(json, false);
}
function PropertyTypesResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : (value['data'].map(PropertyTypeItemDto_1.PropertyTypeItemDtoToJSON)),
        'error': value['error'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
